import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import { Typography } from '@material-ui/core'
import Divider from '@material-ui/core/Divider'
import Tooltip from '@material-ui/core/Tooltip'

import { TableFormats } from '../TableHelpers'
import Genre from '../../constants/genre_demographics.json'
class MakeshiftDrawer extends React.Component {
  static propTypes = {
    data: PropTypes.array,
    entities: PropTypes.object,
    genreDemo: PropTypes.object,
    demoSummary: PropTypes.object,
    open: PropTypes.bool.isRequired,
    screenWidth: PropTypes.number,
    genres: PropTypes.array,
    selectedNetwork: PropTypes.string,
    networksByVolume: PropTypes.array,
    networksByEngagement: PropTypes.array,
    handleSelectedGenre: PropTypes.func,
    fetchNetworkEntities: PropTypes.func.isRequired,
    setRediscoverSelectedGenreNetwork: PropTypes.func.isRequired,
    fetchGenreDemo: PropTypes.func.isRequired,
    fetchGenreDemoSummary: PropTypes.func.isRequired
  }

  constructor (props){
    super(props)
    this.state = {
      selectedGenre: '',
      selectedGenreScore: 0,
      demographics: [],
      thumbnails: [],
      selectedGerneDemo: null,
      colors: ['#6372F2', '#DE5F46', '#5BC89A', '#A06BF2', '#F3A467', '#61D1EF', '#E461EF', '#EFD061', '#6372F2', '#DE5F46', '#5BC89A', '#A06BF2', '#F3A467', '#61D1EF', '#E461EF', '#EFD061'],
      currentIndex: 0,
      endIndex: 0,
      networkImageIndex: 0,
      genreTopicIds: [],
      entitiesList: [],
      topNetworkByVolume: [],
      bottomNetworkByVolume: [],
      topNetworkByEngagement: [],
      bottomNetworkByEngagement: []
    }
  }

  componentDidMount () {
    this.setState({ genreTopicIds: Genre.genres.map(g => g.id)})
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevProps.genres !== this.props.genres && this.props.genres.length > 0) {
      this.setState({
        selectedGenre: this.props.genres[0].name,
        selectedGenreScore: this.props.genres[0].score,
        endIndex: this.props.genres.length - 1,
        selectedGerneDemo: this.state.demographics.filter(demo => demo.genre === this.props.genres[0].name)[0]
      })
      this.props.handleSelectedGenre(this.props.genres[0].name)
      let selectedGenre = Genre.genres.filter(g => g.name === this.props.genres[0].name)[0]
      this.props.fetchGenreDemo(this.props.genres[0].name, selectedGenre.id, this.state.genreTopicIds)
    }

    if (prevProps.networksByEngagement !== this.props.networksByEngagement && this.props.networksByEngagement.length > 0 && this.state.networkImageIndex === 0) {
      this.getNetworkImages()
    }

    if (prevState.selectedGenre !== this.state.selectedGenre) {
      this.setState({ networkImageIndex: 0})
    }

    if (prevState.networkImageIndex !== this.state.networkImageIndex || (prevState.selectedGenre !== this.state.selectedGenre && this.props.networksByEngagement && this.props.networksByEngagement.length > 0 && this.state.networkImageIndex === 0)) {
      this.getNetworkImages()
    }

    if (prevProps.entities !== this.props.entities && this.props.entities && this.props.entities.details && this.props.entities.details.entities) {
      let entities = this.props.entities.details.entities
      let thumbnails = []
      entities.map(e => {
        thumbnails.push({
          name: e.entity.display_name || e.entity.name,
          thumbnail: e.entity.thumbnail,
          index: this.state.entitiesList.indexOf(e.entity.id)
        })
      })
      thumbnails = thumbnails.sort((a, b) => a.index - b.index)
      this.setState({ thumbnails: thumbnails})
    }

    if (prevProps.networksByVolume !== this.props.networksByVolume && this.props.networksByVolume.length > 0) {
      const top = this.props.networksByVolume.slice(0, 3)
      const bottom = this.props.networksByVolume.length > 6 ? this.props.networksByVolume.slice(this.props.networksByVolume.length - 3, this.props.networksByVolume.length) : this.props.networksByVolume.slice(3, this.props.networksByVolume.length)
      this.setState({
        topNetworkByVolume: top,
        bottomNetworkByVolume: bottom
      })
    }

    if (prevProps.networksByEngagement !== this.props.networksByEngagement && this.props.networksByEngagement.length > 0) {
      const top = this.props.networksByEngagement.slice(0, 3)
      const bottom = this.props.networksByEngagement.length > 6 ? this.props.networksByEngagement.slice(this.props.networksByVolume.length - 3, this.props.networksByEngagement.length) : this.props.networksByEngagement.slice(3, this.props.networksByEngagement.length)
      this.setState({
        topNetworkByEngagement: top,
        bottomNetworkByEngagement: bottom
      })
    }
  }

  getNetworkImages = () => {
    let entitiesList = []
    let network = this.props.networksByEngagement[this.state.networkImageIndex].name
    if (this.props.networksByEngagement && this.props.networksByEngagement.length > 0) {
      this.props.setRediscoverSelectedGenreNetwork(network)
    }
    this.props.networksByEngagement.map((e, index) => {
      if (index === this.state.networkImageIndex) {
        let list = this.props.data.filter(d => d['networks'] === e.name && d['topline_genre'] === this.state.selectedGenre)
        list = list.sort((a, b) => parseInt(b['num_alignments']) - parseInt(a['num_alignments']))
        list = list.length > 6 ? list.slice(0, 6) : list
        list.map(l => entitiesList.push(l.id))
      }
    })
    if (entitiesList.length > 0) {
      this.setState({ entitiesList: entitiesList})
    }
  }

  getTopics = (pos) => {
    let currentIndex = this.state.currentIndex
    if (pos === 'right') {
      currentIndex = currentIndex >= this.state.endIndex ? 0 : currentIndex + 1
    } else {
      currentIndex = currentIndex <= 0 ? this.state.endIndex : currentIndex - 1
    }
    this.setState({
      selectedGenre: this.props.genres[currentIndex].name,
      selectedGenreScore: this.props.genres[currentIndex].score,
      currentIndex: currentIndex,
      selectedGerneDemo: this.state.demographics.filter(demo => demo.genre === this.props.genres[currentIndex].name)[0]
    })
    this.props.handleSelectedGenre(this.props.genres[currentIndex].name)
    let selectedGenre = Genre.genres.filter(g => g.name === this.props.genres[currentIndex].name)[0]
    this.props.fetchGenreDemo(this.props.genres[currentIndex].name, selectedGenre.id, this.state.genreTopicIds)
  }

  getPercentage = (value) => {
    if (value && value < 1) {
      return '<1%'
    } else {
      return value ? `${Math.round(value)}%` : '0%'
    }
  }

  getIndex = (index, length) => {
    if (index === 2) {
      return length
    } else if (index === 1) {
      return length -1
    } else if (index === 0) {
      return length -2
    }
  }

  getImage = (type) => {
    let currentIndex = this.state.networkImageIndex
    let index = 0
    if (type === 'Next') {
      index = this.state.networkImageIndex >= this.props.networksByEngagement.length - 1 ? 0 : currentIndex + 1
    } else {
      index = this.state.networkImageIndex === 0 ? this.props.networksByEngagement.length - 1 : currentIndex - 1
    }
    this.setState({ networkImageIndex: index})
  }

  defaultThumb = (name, index) => {
    let data = `<div class='rediscoverNoImg'><span class='rediscoverNoImgText'>${name && name.replace(/[^\w\s]/gi, '').charAt(0)}</span></div>`
    document.getElementById(`rediscover_top_content_${index}`).innerHTML = data
  }

  render () {
    let drawerTitle = this.state.selectedGenre
    let drawerBg = '#4A89F1' //this.state.colors[this.state.currentIndex]
    const demographics = this.props.genreDemo && this.props.genreDemo.details
    const demoSummary = this.props.demoSummary && this.props.demoSummary.details
    let screenWidth = this.props.screenWidth
    return (
      <Box className="slideWrapper" style={{border: `1px solid ${drawerBg}`}}>
        <Box className="d-flex align-items-center justify-content-between drawerheader" style={{backgroundColor: `${drawerBg}` }}>
          <Box className="actionBtn d-flex align-items-center justify-content-center" onClick={() => this.getTopics('left')}>
            <ArrowLeftIcon />
          </Box>
          <Typography className="headerTitle">{drawerTitle}</Typography>
          <Box className="actionBtn d-flex align-items-center justify-content-center" onClick={() => this.getTopics('right')}>
            <ArrowRightIcon />
          </Box>
        </Box>
        <Box className="workArea">
          <Grid container>
            <Grid item xs={12}>
              <Typography className="drawerTitle">Engagement Metrics</Typography>
            </Grid>
            <Box className="panLeft" >
              <Box>
                <Box className="d-flex align-items-center justify-content-between">
                  <Box className="lLabelWidth">
                    <Typography className="drawerLabel">Potential Audience:</Typography>
                  </Box>
                  <Box>
                    <Typography className="labelUnit">{demoSummary && TableFormats.trackerFormatKM(demoSummary.num_users)}</Typography>
                  </Box>
                </Box>
                <Box className="d-flex align-items-center justify-content-between">
                  <Box className="lLabelWidth">
                    <Typography className="drawerLabel labelGray text-lg-right text-sm-left subInfoTxt">Avg. benchmark: </Typography>
                  </Box>
                  <span className="subLabelInfo">{demographics && TableFormats.trackerFormatKM(demographics.average_benchmark)}</span>
                </Box>
              </Box>
            </Box>
            <Box className="panRight">
              <Box className="text-lg-right text-sm-left">
                <Box className="d-flex align-items-center justify-content-lg-start justify-content-sm-between box-xs-between">
                  <Box className="rLabelWidth">
                    <Typography className="drawerLabel text-lg-right text-sm-left">Percent of Total Audience:</Typography>
                  </Box>
                  <Box className="lPercent">
                    <Typography className="labelUnit">{demographics && this.getPercentage(demographics.total_audience)}</Typography>
                  </Box>
                </Box>
                <Box className="d-flex align-items-center justify-content-lg-start justify-content-sm-between box-xs-between">
                  <Box className="rLabelWidth">
                    <Typography className="drawerLabel labelGray text-lg-right text-sm-left subInfoTxt">Avg. benchmark:</Typography>
                  </Box>
                  <span className="subLabelInfo">{demographics && this.getPercentage(demographics.audience_average_benchmark)}</span>
                </Box>
              </Box>
            </Box>
            <Grid item xs={12}>
              <Divider className="drawerDivide" />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <Typography className="drawerTitle">Demographics</Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography className="drawerLabel mb-2 text-right">Male: <span className="labelGray countAlign xsInfo">{demographics && this.getPercentage(demographics.num_male)}</span></Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Box className="d-flex align-items-center">
                    <Typography className="drawerLabel labelCount mb-2 text-right"> &gt;18: </Typography>
                    <span className="labelGray drawerLabel ml-1 xsInfo">{demographics && this.getPercentage(demographics.num_age_under18)}</span>
                  </Box>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Box className="d-flex align-items-center">
                    <Typography className="drawerLabel labelCount mb-2 text-right"> 25-34: </Typography>
                    <span className="labelGray drawerLabel ml-1 xsInfo"> {demographics && this.getPercentage(demographics.num_age25_to34)}</span>
                  </Box>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Box className="d-flex align-items-center lastlabelWrap">
                    <Typography className="drawerLabel labelCount mb-2 text-right lastlabel"> +55: </Typography>
                    <span className="labelGray drawerLabel lastSpan ml-1 xsInfo"> {demographics && this.getPercentage(demographics.num_age55_plus)}</span>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={6} sm={3} md={3}>
                  <Typography className="drawerLabel mb-2 text-lg-right text-sm-left">Female: <span className="labelGray countAlign xsInfo">{demographics && this.getPercentage(demographics.num_female)}</span></Typography>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Box className="d-flex align-items-center">
                    <Typography className="drawerLabel labelCount mb-2 text-right"> 18-24:</Typography>
                    <span className="labelGray drawerLabel ml-1 xsInfo">{demographics && this.getPercentage(demographics.num_age18_to24)}</span>
                  </Box>
                </Grid>
                <Grid item xs={6} sm={3} md={3}>
                  <Box className="d-flex align-items-center">
                    <Typography className="drawerLabel labelCount mb-2 text-right"> 35-54:</Typography>
                    <span className="labelGray drawerLabel ml-1 xsInfo">{demographics && this.getPercentage(demographics.num_age35_to54)}</span>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Divider className="drawerDivide" />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <Typography className="drawerTitle">Top / Bottom Networks by Volume</Typography>
            </Grid>
            { (this.props.networksByVolume && this.props.networksByVolume.length > 0) &&
            <>
              <Grid item xs={12} md={6}>
                { this.state.topNetworkByVolume && this.state.topNetworkByVolume.map((network, index) => {
                      return (
                        <Box key={index} className={network.isSelected ? 'd-flex align-items-center justify-content-between labelActive' : 'd-flex align-items-center justify-content-between'}>
                          <Tooltip title={screenWidth >= 960 && network.name.length>=16 ? network.name : '' } placement="top"><Typography className={'drawerLabel mb-2 text-left labelWidth ' + (screenWidth >= 960 && network.name.length>=16 ? 'labelEllipses' : '')}>{index + 1}. {network.name}</Typography></Tooltip> <span className="labelGray drawerLabel mb-2 text-right labelRight-3">{this.getPercentage(network.percentage)}</span>
                        </Box>
                      )
                    })
                    }
              </Grid>
              <Grid item xs={12} md={6}>
                { this.state.bottomNetworkByVolume && this.state.bottomNetworkByVolume.map((network, index) => {
                      return (
                        <Box key={index} className={network.isSelected ? 'd-flex align-items-center justify-content-between labelActive' : 'd-flex align-items-center justify-content-between'}>
                          <Tooltip title={screenWidth >= 960 && network.name.length>=16 ? network.name : '' } placement="top"><Typography className={'drawerLabel mb-2 text-left labelWidth ' + (screenWidth >= 960 && network.name.length>=16 ? 'labelEllipses' : '')}>{this.getIndex(index, this.props.networksByVolume.length)}. {network.name}</Typography></Tooltip> <span className="labelGray drawerLabel mb-2 text-right">{this.getPercentage(network.percentage)}</span>
                        </Box>
                      )
                    })
                    }
              </Grid>
            </>
              }
            <Grid item xs={12}>
              <Divider className="drawerDivide" />
            </Grid>
          </Grid>
          <Grid container>
            <Grid item xs={12}>
              <Typography className="drawerTitle">Top / Bottom Networks by Engagement</Typography>
            </Grid>
            { (this.props.networksByEngagement && this.props.networksByEngagement.length > 0) &&
            <>
              <Grid item xs={12} md={6}>
                { this.state.topNetworkByEngagement && this.state.topNetworkByEngagement.map((network, index) => {
                      return (
                        <Box key={index} className={network.isSelected ? 'd-flex align-items-center justify-content-between labelActive' : 'd-flex align-items-center justify-content-between'}>
                          <Tooltip title={screenWidth >= 960 && network.name.length>=16 ? network.name : '' } placement="top"><Typography className={'drawerLabel mb-2 text-left labelWidth ' + (screenWidth >= 960 && network.name.length>=16 ? 'labelEllipses' : '')}>{index + 1}. {network.name}</Typography></Tooltip> <span className="labelGray drawerLabel mb-2 text-right labelRight-3">{this.getPercentage(network.percentage)}</span>
                        </Box>
                      )
                    })
                    }
              </Grid>
              <Grid item xs={12} md={6}>
                { this.state.bottomNetworkByEngagement && this.state.bottomNetworkByEngagement.map((network, index) => {
                      return (
                        <Box key={index} className={network.isSelected ? 'd-flex align-items-center justify-content-between labelActive' : 'd-flex align-items-center justify-content-between'}>
                          <Tooltip title={screenWidth >= 960 && network.name.length>=16 ? network.name : '' } placement="top"><Typography className={'drawerLabel mb-2 text-left labelWidth ' + (screenWidth >= 960 && network.name.length>=16 ? 'labelEllipses' : '')}>{this.getIndex(index, this.props.networksByEngagement.length)}. {network.name}</Typography></Tooltip> <span className="labelGray drawerLabel mb-2 text-right">{this.getPercentage(network.percentage)}</span>
                        </Box>
                      )
                    })
                    }
              </Grid>
            </>
              }
            <Grid item xs={12}>
              <Divider className="drawerDivide" />
            </Grid>
          </Grid>
        </Box>
      </Box>
    )
  }
}

export default MakeshiftDrawer
